import { DEFAULT_CURRENCY, currencyChoices } from '@almanac/shared';
import { useCurrentUser, useSetCurrency } from '../lib/me.js';

/**
 * Settings control for the Budget display currency. Mirrors
 * DocumentAiSection: a radio group persisted on the user row via
 * `PATCH /api/shared/me`, so the choice follows the user across
 * devices. The stored preference is nullable (null ⇒ CHF), so an
 * untouched account shows the default selected.
 *
 * Display-only: switching currency relabels the figures, it never
 * converts them — the budget stores plain numbers.
 */
export function CurrencySection() {
  const me = useCurrentUser();
  const setCurrency = useSetCurrency();
  const current = me.data?.currency ?? DEFAULT_CURRENCY;

  return (
    <div className="home-layout">
      <span className="reminder-toggle__heading">Budget currency</span>
      <p className="home-layout__hint">
        The label shown next to budget figures. Changing it doesn&rsquo;t convert
        any amounts.
      </p>
      <div className="home-layout-options" role="radiogroup" aria-label="Budget currency">
        {currencyChoices.map((code) => {
          const selected = current === code;
          return (
            <button
              key={code}
              type="button"
              role="radio"
              aria-checked={selected}
              className={`home-layout-option${selected ? ' home-layout-option--selected' : ''}`}
              onClick={() => {
                if (!selected) setCurrency.mutate(code === DEFAULT_CURRENCY ? null : code);
              }}
            >
              <span className="home-layout-option__radio" aria-hidden="true" />
              <span className="home-layout-option__text">
                <span className="home-layout-option__title">{code}</span>
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
